var map = {
	"./book/A4-P/sombra-capa-interna.svg": 675,
	"./book/A4-R/sombra-capa-interna.svg": 676,
	"./book/A5-P/sombra-capa-interna.svg": 677,
	"./book/A5-R/sombra-capa-interna.svg": 678
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 674;